const InlineLoadingIndicator = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{
      margin: 'auto',
      background: 'rgb(255, 255, 255)',
      display: 'block',
      shapeRendering: 'auto',
    }}
    width="64px"
    height="64px"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <g transform="rotate(0 50 50)">
      <rect
        x="47.5"
        y="23"
        rx="2.5"
        ry="2.52"
        width="5"
        height="12"
        fill="#dee3e6"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="0.9615384615384615s"
          begin="-0.8814102564102564s"
          repeatCount="indefinite"
        />
      </rect>
    </g>
    <g transform="rotate(30 50 50)">
      <rect
        x="47.5"
        y="23"
        rx="2.5"
        ry="2.52"
        width="5"
        height="12"
        fill="#dee3e6"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="0.9615384615384615s"
          begin="-0.8012820512820512s"
          repeatCount="indefinite"
        />
      </rect>
    </g>
    <g transform="rotate(60 50 50)">
      <rect
        x="47.5"
        y="23"
        rx="2.5"
        ry="2.52"
        width="5"
        height="12"
        fill="#dee3e6"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="0.9615384615384615s"
          begin="-0.7211538461538461s"
          repeatCount="indefinite"
        />
      </rect>
    </g>
    <g transform="rotate(90 50 50)">
      <rect
        x="47.5"
        y="23"
        rx="2.5"
        ry="2.52"
        width="5"
        height="12"
        fill="#dee3e6"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="0.9615384615384615s"
          begin="-0.641025641025641s"
          repeatCount="indefinite"
        />
      </rect>
    </g>
    <g transform="rotate(120 50 50)">
      <rect
        x="47.5"
        y="23"
        rx="2.5"
        ry="2.52"
        width="5"
        height="12"
        fill="#dee3e6"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="0.9615384615384615s"
          begin="-0.5608974358974359s"
          repeatCount="indefinite"
        />
      </rect>
    </g>
    <g transform="rotate(150 50 50)">
      <rect
        x="47.5"
        y="23"
        rx="2.5"
        ry="2.52"
        width="5"
        height="12"
        fill="#dee3e6"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="0.9615384615384615s"
          begin="-0.4807692307692307s"
          repeatCount="indefinite"
        />
      </rect>
    </g>
    <g transform="rotate(180 50 50)">
      <rect
        x="47.5"
        y="23"
        rx="2.5"
        ry="2.52"
        width="5"
        height="12"
        fill="#dee3e6"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="0.9615384615384615s"
          begin="-0.4006410256410256s"
          repeatCount="indefinite"
        />
      </rect>
    </g>
    <g transform="rotate(210 50 50)">
      <rect
        x="47.5"
        y="23"
        rx="2.5"
        ry="2.52"
        width="5"
        height="12"
        fill="#dee3e6"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="0.9615384615384615s"
          begin="-0.3205128205128205s"
          repeatCount="indefinite"
        />
      </rect>
    </g>
    <g transform="rotate(240 50 50)">
      <rect
        x="47.5"
        y="23"
        rx="2.5"
        ry="2.52"
        width="5"
        height="12"
        fill="#dee3e6"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="0.9615384615384615s"
          begin="-0.24038461538461536s"
          repeatCount="indefinite"
        />
      </rect>
    </g>
    <g transform="rotate(270 50 50)">
      <rect
        x="47.5"
        y="23"
        rx="2.5"
        ry="2.52"
        width="5"
        height="12"
        fill="#dee3e6"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="0.9615384615384615s"
          begin="-0.16025641025641024s"
          repeatCount="indefinite"
        />
      </rect>
    </g>
    <g transform="rotate(300 50 50)">
      <rect
        x="47.5"
        y="23"
        rx="2.5"
        ry="2.52"
        width="5"
        height="12"
        fill="#dee3e6"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="0.9615384615384615s"
          begin="-0.08012820512820512s"
          repeatCount="indefinite"
        />
      </rect>
    </g>
    <g transform="rotate(330 50 50)">
      <rect
        x="47.5"
        y="23"
        rx="2.5"
        ry="2.52"
        width="5"
        height="12"
        fill="#dee3e6"
      >
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="0.9615384615384615s"
          begin="0s"
          repeatCount="indefinite"
        />
      </rect>
    </g>
  </svg>
);

export default InlineLoadingIndicator;
